import { Box } from "@material-ui/core";

import { publicPath } from "@ip-utils";
import { Loader } from "@ip-widgets";

export default function SplashScreen() {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      height="100vh"
      justifyContent="center"
    >
      <Box maxWidth={200} width="80%">
        <Box marginBottom={3}>
          <img alt="iglu" src={publicPath("/media/iglu.svg")} width="100%" />
        </Box>
        <Loader loading={true} />
      </Box>
    </Box>
  );
}
